import { render } from "./CookiebarMainArea.ce.vue?vue&type=template&id=040ef0c1"
import script from "./CookiebarMainArea.ce.vue?vue&type=script&lang=js"
export * from "./CookiebarMainArea.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__